export type Suit = 'hearts' | 'diamonds' | 'clubs' | 'spades';
export type Rank =
  | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10'
  | 'J' | 'Q' | 'K' | 'A';

export interface CardProps {
  suit: Suit;
  rank: Rank;
  faceDown?: boolean;
  className?: string;
}

const suitSymbols: Record<Suit, string> = {
  hearts: '♥',
  diamonds: '♦',
  clubs: '♣',
  spades: '♠',
};

const suitHex: Record<Suit, string> = {
  hearts: '#e5243f',
  diamonds: '#3b82f6',
  clubs: '#22a55b',
  spades: '#1e293b',
};

/** Standard playing card ratio: 2.5:3.5 (width:height) */
const CARD_ASPECT = 'aspect-[5/7]';

export function Card({ suit, rank, faceDown = false, className = '' }: CardProps) {
  if (faceDown) {
    return (
      <div
        className={`
          ${CARD_ASPECT} w-[4rem] min-w-[2.5rem] rounded-lg
          bg-gradient-to-br from-indigo-800 to-indigo-950 border border-indigo-400/30
          shadow-lg flex items-center justify-center overflow-hidden
          ${className}
        `}
      >
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `repeating-linear-gradient(
              45deg,
              transparent,
              transparent 4px,
              rgba(255,255,255,0.06) 4px,
              rgba(255,255,255,0.06) 8px
            )`,
          }}
        />
      </div>
    );
  }

  const color = suitHex[suit];

  return (
    <div
      className={`
        ${CARD_ASPECT} w-[4rem] min-w-[2.5rem] rounded-lg
        bg-white shadow-lg relative overflow-hidden
        border border-slate-300/80
        ${className}
      `}
    >
      {/* Top-left: rank only */}
      <div className="absolute top-[8%] left-[15%] leading-none" style={{ color }}>
        <span className="font-black" style={{ fontSize: '4.0em' }}>{rank}</span>
      </div>

      {/* Large center suit */}
      <div className="absolute inset-0 flex items-center justify-center" style={{ color, paddingTop: '40%' }}>
        <span style={{ fontSize: '5.0em', lineHeight: 1 }}>{suitSymbols[suit]}</span>
      </div>
    </div>
  );
}
